import { EmailData } from '../types';

export class EmailService {
  private static async sendEmailViaPHP(emailData: EmailData): Promise<{ success: boolean; message: string }> {
    try {
      console.log('📧 DÉBOGAGE: Envoi via PHP:', emailData);
      
      const response = await fetch('/send-email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(emailData),
      });

      console.log('📧 DÉBOGAGE: Réponse PHP:', response.status, response.statusText);

      let result: { success: boolean; message?: string } | null = null;
      try {
        result = await response.json();
      } catch (jsonError) {
        const rawText = await response.text();
        console.error('❌ Réponse non-JSON:', rawText);
        return {
          success: false,
          message: `Réponse invalide du serveur (status ${response.status} ${response.statusText})`,
        };
      }

      console.log('📧 DÉBOGAGE: Résultat PHP:', result);

      if (!response.ok || !result?.success) {
        const errorMessage = result?.message || `Erreur serveur: ${response.status} ${response.statusText}`;
        console.error('❌ Erreur PHP:', errorMessage);
        return {
          success: false,
          message: errorMessage,
        };
      }
      
      return {
        success: true,
        message: result.message || 'Email envoyé avec succès !',
      };
    } catch (error) {
      console.error('❌ Erreur lors de l\'envoi de l\'email:', error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Erreur inconnue lors de l\'envoi de l\'email',
      };
    }
  }

  public static async sendEmail(emailData: EmailData): Promise<{ success: boolean; message: string }> {
    console.log('🚀 Début de sendEmail avec:', emailData);
    
    try {
      const result = await this.sendEmailViaPHP(emailData);
      
      if (result.success) {
        console.log('✅ sendEmail: Succès');
      } else {
        console.log('❌ sendEmail: Échec -', result.message);
      }

      return result;
    } catch (error) {
      console.error('💥 sendEmail: Exception:', error);
      return {
        success: false,
        message: `Erreur: ${error instanceof Error ? error.message : 'Erreur inconnue'}`
      };
    }
  }

  public static validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  public static generateLegalEmailTemplate(subject: string, content: string): string {
    return `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
        <div style="background: #667eea; color: white; padding: 20px; text-align: center;">
          <h1 style="margin: 0;">JudicIA - Assistant Legal IA</h1>
          <p style="margin: 10px 0 0 0;">Spécialisé en droit belge, européen et international</p>
        </div>
        
        <div style="padding: 20px; background: white;">
          <h2 style="color: #333; margin-bottom: 20px;">${subject}</h2>
          
          <div style="line-height: 1.6; color: #555;">
            ${content.replace(/\n/g, '<br>')}
          </div>
          
          <hr style="margin: 30px 0; border: none; border-top: 1px solid #eee;">
          
          <div style="font-size: 12px; color: #999; text-align: center;">
            <p>Cet email a été généré par JudicIA, votre assistant legal IA.</p>
            <p>Pour toute question, contactez-nous via l'application.</p>
          </div>
        </div>
      </div>
    `;
  }
} 